export enum PositionAuditType {
  AUTO = 'Auto',
  MANUAL = 'Manual'
}
